import { render } from "./CreateRbdImage.vue?vue&type=template&id=3123c2ba&scoped=true"
import script from "./CreateRbdImage.vue?vue&type=script&lang=js"
export * from "./CreateRbdImage.vue?vue&type=script&lang=js"

import "./CreateRbdImage.vue?vue&type=style&index=0&id=3123c2ba&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3123c2ba"]])

export default __exports__